<template>
    <section class="page2">
        <div class="top-image index-0">
            <img src="~@/assets/img/section-bot.png" alt="" />
        </div>
           <div class="column">
                <div class="text-bold text-white text-bigger p4">
                    Agora, reflita:
                </div>
                <div class="conteudo text-left p3">
                    <div class="col1">
                       <div class="article text-center text-orange text-bigger text-bold">
                            <p class="content">Você já começou a adequar os processos do seu RH?</p>
                       </div>
                    </div>
                    <div class="col2">
                        <div class="article text-center text-orange text-bigger text-bold">
                            <p class="content">Você sabe como elaborar o seu plano estratégico para atender a lei e evitar multas?</p>
                       </div>
                    </div>
                </div>
           </div>
    </section>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page2 {
    position: relative;
    background-image: url("~@/assets/img/sectionred-bg.png");
    background-position-x: right;
    background-size:contain;
    background-color: #911717;
    background-repeat: no-repeat;
    height: 768px;

    padding-right: 20px;
    padding-left: 20px;
    .column{
        display: flex;
        flex-direction: column;
        height: 85%;

    }
    .p4{
        padding-top: 80px;
        
    }
    
    .conteudo{
        justify-content: space-between;
        align-items: center;
        align-self: center;
        width: 100%;
        height: 100%;

        
        .col1{
            max-width: 556px;
            width: 556px;
            flex-basis: 0;
            flex-grow: 1;

        }
        .col2{
            max-width: 556px;
            width: 556px;
            flex-basis: 0;
            flex-grow: 1;
        }
    }
    .article{
        padding: 40px 30px 40px 30px;
        border-radius: 30px;
        background: white;
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        
        font-size: 2.2rem;
        line-height: 37px;

            padding-bottom: 30px;


    }
    
    .content{
        max-width: 90%;
    }

    .top-image {
        top: -102px;
        img {
            height: 100%;
        }
    }

    @media (max-width: 900px) {
        height: auto;
        padding: 30px 0 30px 0;
        .p4{
            padding-top: 20px;
        }

        .column{
            height: auto;
        }
        .top-image{
            display: none;
        }
        .conteudo {
            max-width: 90%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: auto;
            .col1{
                padding-right: 0;
                max-width: 100%;

            }
            .col2 {
                padding-top: 30px;
                max-width: 100%;

            }
        }
        .article{
            max-width: 100%;
            font-size: 1.8rem;
        }
        .content{
            max-width: 100%;
        }
    }
}
</style> 